<div>
  <mic-breadcrumb id="logs-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/logs" label="{{ translationService.translate('LogsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="logs-heading">{{ translationService.translate('LogsText') }}</h2>

  <mat-tab-group id="tabs" mat-stretch-tabs="false" class="mt-2" (selectedTabChange)="onTabChange($event)">
    <mat-tab id="info-tab" label="{{ translationService.translate('sfAuditTrailText') }}">
      <div>
        <mat-card>
          <mat-card-content class="cam-table mt-2 ml-2">
            <form [formGroup]="auditTrailForm" (ngSubmit)="submitSearch()">
              <mat-card-title class="search-criteria-title">{{ translationService.translate('searchCriteriaText') }} </mat-card-title>
              <div class="filter-container">
                <!-- Info Message Row -->
                <div class="info-message-wrapper">
                  <mic-status class="info-message">
                    <mic-icon class="sm" icon="info"></mic-icon>
                    <span class="info-text">{{ this.translationService.translate('dateFilterAuditLogInfoText') }}</span>
                  </mic-status>
                </div>

                <!-- Filter Controls Row -->

                <mat-form-field appearance="fill" class="filter-item">
                  <mat-label>{{ translationService.translate('dateFilterText') }}</mat-label>
                  <mat-select
                    formControlName="dateFilter"
                    (selectionChange)="onDateFilterChange($event)"
                    placeholder="{{ this.translationService.translate('selectDateRangeText') }}"
                    [required]="!hasAuditBarcode"
                  >
                    <mat-option *ngFor="let option of dateFilterOptions" [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="auditTrailForm.get('dateFilter')?.hasError('required')">
                    {{ translationService.translate('dateFilterRequiredText') }}
                  </mat-error>
                </mat-form-field>

                <!-- Custom Date Range Picker (shown only when 'custom' is selected) -->
                @if (isCustomDateRange) {
                <mat-form-field appearance="fill" class="filter-item" formGroupName="customDateRange">
                  <mat-label>{{ translationService.translate('customDateRangeText') }}</mat-label>
                  <mat-date-range-input [rangePicker]="rangePicker1" [min]="minDate" [max]="maxDate">
                    <input
                      matStartDate
                      formControlName="creationDateStart"
                      placeholder="Start date"
                      [required]="!hasAuditBarcode"
                      (dateChange)="onStartDateChange($event)"
                      (keydown.enter)="$event.preventDefault()"
                    />
                    <input
                      matEndDate
                      formControlName="creationDateEnd"
                      placeholder="End date"
                      [required]="!hasAuditBarcode"
                      (dateChange)="onEndDateChange($event)"
                      (keydown.enter)="$event.preventDefault()"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="rangePicker1"></mat-datepicker-toggle>
                  <mat-date-range-picker #rangePicker1 [startAt]="maxDate"></mat-date-range-picker>
                  @if (auditTrailForm.get('customDateRange.creationDateStart')?.hasError('required') ||
                  auditTrailForm.get('customDateRange.creationDateEnd')?.hasError('required') ||
                  auditTrailForm.get('customDateRange.creationDateStart')?.hasError('dateRangeExceeded') ||
                  auditTrailForm.get('customDateRange.creationDateEnd')?.hasError('dateRangeExceeded')) {
                  <mat-error>
                    @if (auditTrailForm.get('customDateRange.creationDateStart')?.hasError('required') ||
                    auditTrailForm.get('customDateRange.creationDateEnd')?.hasError('required')) {
                    {{ translationService.translate('customDateRangeRequiredText') }}
                    } @if (auditTrailForm.get('customDateRange.creationDateStart')?.hasError('dateRangeExceeded') ||
                    auditTrailForm.get('customDateRange.creationDateEnd')?.hasError('dateRangeExceeded')) {
                    {{ translationService.translate('maxRangeOneYearText') }}
                    }
                  </mat-error>
                  }
                </mat-form-field>
                }

                <!--{{ translationService.translate('maxRangeOneYearText') }}-->

                <!-- Action Buttons -->
                <!-- Right side: buttons -->
                <div class="filter-actions">
                  <button
                    type="button"
                    id="reset-filters"
                    (click)="clearSelection()"
                    mat-flat-button
                    color="accent"
                    aria-label="reset filters"
                    [disabled]="isAuditTrailSearchLoading"
                  >
                    <mat-icon role="img" aria-label="refresh">refresh</mat-icon>
                    {{ this.translationService.translate('clearSelectionText') }}
                  </button>

                  <button type="submit" id="audit-search-button" mat-flat-button color="primary" [disabled]="isAuditTrailSearchLoading">
                    @if (isAuditTrailSearchLoading) {
                    <mat-icon class="loading-icon">autorenew</mat-icon>
                    {{ translationService.translate('loadingText') || 'Loading...' }}
                    } @else {
                    <mat-icon>search</mat-icon>
                    {{ translationService.translate('searchButtonText') }}
                    }
                  </button>

                  @if (isEarlyAccessEnabled) {
                  <button
                    type="button"
                    id="audit-export-button"
                    mat-flat-button
                    color="primary"
                    (click)="openAuditExportModal()"
                    [disabled]="!canOpenAuditExport() || isAuditTrailExportLoading"
                  >
                    @if (isAuditTrailExportLoading) {
                    <mat-icon class="loading-icon">autorenew</mat-icon>
                    {{ translationService.translate('loadingText') || 'Exporting...' }}
                    } @else {
                    <mat-icon>download</mat-icon>
                    {{ translationService.translate('exportButtonText') }}
                    }
                  </button>
                  }
                </div>
              </div>

              <mat-card-title class="additional-filter-title">{{ translationService.translate('additionalFilterText') }} </mat-card-title>
              <div class="filter-container">
                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="userId"
                    [data]="userLoginNames"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('selectUserIdText') }}"
                    label="{{ translationService.translate('searchUserIdText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <mat-form-field subscriptSizing="dynamic" class="filter-item">
                  <mat-label>{{ this.translationService.translate('searchBarcodeText') }}</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="barcode"
                    placeholder="{{ this.translationService.translate('enterBarcodeText') }}"
                  />
                </mat-form-field>

                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="location"
                    [data]="locations"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('selectPlantSiteText') }}"
                    label="{{ translationService.translate('searchPlantSiteText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="postName"
                    [data]="egraPostNames"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('enterPostText') }}"
                    label="{{ translationService.translate('searchPostText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="auditAction"
                    [data]="auditActionList"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('selectActionText') }}"
                    label="{{ translationService.translate('searchActionText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <!--<mat-form-field appearance="fill" class="filter-item" style="width: 20%; max-width: 350px">
                  <mat-label>{{ this.translationService.translate('searchDateText') }}</mat-label>
                  <mat-date-range-input [rangePicker]="rangePicker1">
                    <input
                      matStartDate
                      placeholder="{{ this.translationService.translate('selectDateText') }}"
                      autocomplete="off"
                      formControlName="creationDateStart"
                    />
                    <input
                      matEndDate
                      placeholder="{{ this.translationService.translate('dateRangeText') }}"
                      autocomplete="off"
                      formControlName="creationDateEnd"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="rangePicker1"></mat-datepicker-toggle>
                  <mat-date-range-picker #rangePicker1></mat-date-range-picker>
                </mat-form-field>-->
              </div>

              <!--<div class="filter-container" style="display: flex; align-items: center; gap: 16px">
                <mat-form-field subscriptSizing="dynamic" class="filter-item" style="width: 15%; max-width: 300px">
                  <mat-label>{{ this.translationService.translate('searchPostText') }}</mat-label>
                  <mat-select formControlName="postName" placeholder="{{ this.translationService.translate('enterPostText') }}">
                    @for (post of egraPostNames; track post) {
                    <mat-option [value]="post">
                      {{ post }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" subscriptSizing="dynamic" class="filter-item" style="width: 15%; max-width: 300px">
                  <mat-label>{{ this.translationService.translate('searchActionText') }}</mat-label>
                  <mat-select formControlName="auditAction" placeholder="{{ this.translationService.translate('selectActionText') }}">
                    @for (auditAction of auditActionList; track auditAction) {
                    <mat-option [value]="auditAction">
                      {{ auditAction }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>-->
            </form>

            <mic-table #auditTable class="table-stripped" id="audit-table" [config]="tableConfigAudit" [fetcher]="fetcherAudit">
              <ng-container *micTableNoData>
                <mic-empty-state icon="layers_clear" title="No Audit trail found"></mic-empty-state>
              </ng-container>

              <!--<ng-container *micTableColumnSelector>
                <button id="table-column-selector-audit" mat-flat-button class="column-button">
                  <mat-icon>view_column</mat-icon>{{ translationService.translate('columnsButtonText') }}
                </button>
              </ng-container>-->
            </mic-table>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab id="info-tab-bo" label="{{ translationService.translate('boAuditTrailText') }}">
      <div>
        <mat-card>
          <mat-card-content class="cam-table mt-2 ml-2">
            <form [formGroup]="backOfficeAuditTrailForm">
              <div class="filter-container">
                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="userId"
                    [data]="userLoginNames"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('selectUserIdText') }}"
                    label="{{ translationService.translate('searchUserIdText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="action"
                    [data]="actionList"
                    attribute="label"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('selectActionText') }}"
                    label="{{ translationService.translate('searchActionText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <mat-form-field appearance="fill" class="filter-item">
                  <mat-label>{{ this.translationService.translate('searchBarcodeText') }}</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="barcode"
                    maxlength="10"
                    placeholder="{{ this.translationService.translate('enterBarcodeText') }}"
                    (keydown.enter)="submitSearchBO()"
                  />
                </mat-form-field>

                <mat-form-field appearance="fill" class="filter-item">
                  <mat-label>{{ this.translationService.translate('searchByWorkOrdersText') }}</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="workOrderNumber"
                    maxlength="10"
                    placeholder="{{ this.translationService.translate('enterWorkOrderNumText') }}"
                    (keydown.enter)="submitSearchBO()"
                  />
                </mat-form-field>

                <mat-form-field appearance="fill" class="filter-item">
                  <mat-label>{{ this.translationService.translate('searchDateText') }}</mat-label>
                  <mat-date-range-input [rangePicker]="rangePicker">
                    <input
                      matStartDate
                      placeholder="{{ this.translationService.translate('selectDateText') }}"
                      autocomplete="off"
                      formControlName="createDateStart"
                    />
                    <input
                      matEndDate
                      placeholder="{{ this.translationService.translate('dateRangeText') }}"
                      autocomplete="off"
                      formControlName="createDateEnd"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                  <mat-date-range-picker #rangePicker></mat-date-range-picker>
                </mat-form-field>

                <div class="filter-actions">
                  <button
                    id="reset-filters-bo"
                    (click)="clearBoSelection()"
                    mat-flat-button
                    color="accent"
                    aria-label="reset filters"
                    [disabled]="isBoAuditSearchLoading"
                  >
                    <mat-icon role="img" aria-label="refresh">refresh</mat-icon>
                    {{ this.translationService.translate('clearSelectionText') }}
                  </button>

                  <button
                    id="bo-search-button"
                    mat-flat-button
                    color="primary"
                    (click)="submitSearchBO()"
                    [disabled]="isBoAuditSearchLoading"
                  >
                    @if (isBoAuditSearchLoading) {
                    <mat-icon class="loading-icon">autorenew</mat-icon>
                    {{ translationService.translate('loadingText') || 'Loading...' }}
                    } @else {
                    <mat-icon>search</mat-icon>
                    {{ translationService.translate('searchButtonText') }}
                    }
                  </button>

                  @if (isEarlyAccessEnabled) {
                  <button
                    id="bo-audit-export-button"
                    mat-flat-button
                    color="primary"
                    (click)="openBoAuditExportModal()"
                    [disabled]="!canOpenBoAuditExport() || isBoAuditExportLoading"
                  >
                    @if (isBoAuditExportLoading) {
                    <mat-icon class="loading-icon">autorenew</mat-icon>
                    {{ translationService.translate('loadingText') || 'Exporting...' }}
                    } @else {
                    <mat-icon>download</mat-icon>
                    {{ translationService.translate('exportButtonText') }}
                    }
                  </button>
                  }
                </div>
              </div>
            </form>

            @if (boAuditTableActive) {
            <mic-table #boAuditTable class="table-stripped" id="bo-audit-table" [config]="tableConfig" [fetcher]="fetcher">
              <ng-container *micTableNoData>
                <mic-empty-state icon="layers_clear" title="No Back office Audit trail found"></mic-empty-state>
              </ng-container>
            </mic-table>
            }
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab id="info-tab-txn" label="{{ translationService.translate('transactionLogText') }}">
      <div>
        <mat-card>
          <mat-card-content class="cam-table mt-2 ml-2">
            <form [formGroup]="transactionLogForm" (ngSubmit)="submitSearchTransactionLog()">
              <div class="filter-container">
                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="userId"
                    [data]="userLoginNames"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('selectUserIdText') }}"
                    label="{{ translationService.translate('searchUserIdText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <mat-form-field appearance="fill" subscriptSizing="dynamic" class="filter-item">
                  <mat-label>{{ this.translationService.translate('transactionTypeText') }}</mat-label>
                  <mat-select
                    formControlName="transactionType"
                    placeholder="{{ this.translationService.translate('selectTransactionTypeText') }}"
                    (click)="loadTransactionTypeOptions()"
                    (keydown.enter)="loadTransactionTypeOptions()"
                  >
                    @if (isTransactionTypeLoading) {
                    <mat-option disabled>{{ this.translationService.translate('loadingText') || 'Loading...' }}</mat-option>
                    } @if (!isTransactionTypeLoading && transactionTypeList.length === 0) {
                    <mat-option disabled>{{
                      this.translationService.translate('noDataFoundText') || 'No transaction types found'
                    }}</mat-option>
                    } @for (txnType of transactionTypeList; track txnType) {
                    <mat-option [value]="txnType">
                      {{ txnType }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" subscriptSizing="dynamic" class="filter-item">
                  <mat-label>{{ this.translationService.translate('transactionDateText') }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="txnDatePicker"
                    [max]="maxTransactionDate"
                    placeholder="{{ this.translationService.translate('selectDateText') }}"
                    autocomplete="off"
                    formControlName="transactionDate"
                  />
                  <mat-datepicker-toggle matSuffix [for]="txnDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #txnDatePicker></mat-datepicker>
                </mat-form-field>

                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="transactionResult"
                    [data]="transactionResultList"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('selectTransactionResultText') }}"
                    label="{{ translationService.translate('transactionResultText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>

                <button
                  id="reset-filters-txn"
                  (click)="clearTransactionLogSelection()"
                  mat-flat-button
                  color="accent"
                  aria-label="reset filters"
                  [disabled]="isTransactionLogSearchLoading"
                >
                  <mat-icon role="img" aria-label="refresh">refresh</mat-icon>
                  {{ this.translationService.translate('clearSelectionText') }}
                </button>

                <button
                  id="txn-search-button"
                  mat-flat-button
                  color="primary"
                  (click)="submitSearchTransactionLog()"
                  [disabled]="isTransactionLogSearchLoading"
                >
                  @if (isTransactionLogSearchLoading) {
                  <mat-icon class="loading-icon">autorenew</mat-icon>
                  {{ translationService.translate('loadingText') || 'Loading...' }}
                  } @else {
                  <mat-icon>search</mat-icon>
                  {{ translationService.translate('searchButtonText') }}
                  }
                </button>
              </div>
            </form>

            @if (transactionLogTableActive) {
            <mic-table
              #transactionLogTable
              class="table-stripped"
              id="transaction-log-table"
              [config]="tableConfigTransactionLog"
              [fetcher]="fetcherTransactionLog"
            >
              <ng-container *micTableNoData>
                <mic-empty-state icon="layers_clear" title="No Transaction Log found"></mic-empty-state>
              </ng-container>
            </mic-table>
            }
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    @if (isHubLogEnabled) {
    <mat-tab id="info-tab-hub" label="{{ translationService.translate('hubEventLogText') }}">
      <div>
        <mat-card class="hub-log-card">
          <mat-card-content class="cam-table mt-2 ml-2">
            <form [formGroup]="hubLogForm">
              <div class="hub-log-title-row">
                <mat-card-title class="search-criteria-title">{{ translationService.translate('searchCriteriaText') }} </mat-card-title>
                <mic-link
                  icon="delete"
                  [label]="translationService.translate('clearLogsText')"
                  (click)="clearHubLogs($event)"
                  (keydown.enter)="clearHubLogs($event)"
                  (keydown.space)="clearHubLogs($event)"
                ></mic-link>
              </div>

              <div class="filter-container">
                <div class="info-message-wrapper">
                  <mic-status class="info-message">
                    <mic-icon class="sm" icon="info"></mic-icon>
                    <span class="info-text">{{ this.translationService.translate('dateFilterHubEventLogText') }}</span>
                  </mic-status>
                </div>
              </div>

              <div class="filter-container filter-container--top">
                <mat-form-field appearance="fill" subscriptSizing="dynamic" class="filter-item">
                  <mat-label>{{ this.translationService.translate('processText') }}</mat-label>
                  <mat-select
                    formControlName="process"
                    placeholder="{{ this.translationService.translate('processText') }}"
                    (click)="loadHubProcessOptions()"
                    (keydown.enter)="loadHubProcessOptions()"
                  >
                    @if (isHubProcessLoading) {
                    <mat-option disabled>{{ this.translationService.translate('loadingText') || 'Loading...' }}</mat-option>
                    } @if (!isHubProcessLoading && hubProcess.length === 0) {
                    <mat-option disabled>{{ this.translationService.translate('noDataFoundText') || 'No process found' }}</mat-option>
                    } @for (process of hubProcess; track process) {
                    <mat-option [value]="process">
                      {{ process }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <div class="filter-item">
                  <mic-dropdown-search
                    micDropdownAccessibility
                    formControlName="status"
                    [data]="hubStatus"
                    [widthConfig]="{ width: '100%' }"
                    placeholder="{{ translationService.translate('searchByStatusText') }}"
                    label="{{ translationService.translate('searchByStatusText') }}"
                    searchPlaceholder="Search"
                    subscriptSizing="dynamic"
                    [multiple]="false"
                  >
                  </mic-dropdown-search>
                </div>
                <mat-form-field appearance="fill" class="filter-item">
                  <mat-label>{{ this.translationService.translate('creationDateText') }}</mat-label>
                  <input matInput placeholder="dd/mm/yyyy" [matDatepicker]="outlinePicker" autocomplete="off" formControlName="date" />
                  <mat-datepicker-toggle matSuffix [for]="outlinePicker"></mat-datepicker-toggle>
                  <mat-datepicker #outlinePicker></mat-datepicker>
                </mat-form-field>

                <div class="filter-label-inline">
                  <mat-label>{{ this.translationService.translate('betweenText') }}</mat-label>
                </div>

                <div class="filter-item filter-item--time" (mousedown)="onTimePickerInteract('timeFrom')">
                  <mic-timepicker id="hub-time-from" formControlName="timeFrom"></mic-timepicker>
                </div>

                <div class="filter-label-inline">
                  <mat-label>{{ this.translationService.translate('andText') }}</mat-label>
                </div>

                <div class="filter-item filter-item--time" (mousedown)="onTimePickerInteract('timeTo')">
                  <mic-timepicker id="hub-time-to" formControlName="timeTo"></mic-timepicker>
                </div>

                <button
                  id="reset-filters-hub"
                  (click)="clearHubSelection()"
                  mat-flat-button
                  color="accent"
                  aria-label="reset filters"
                  [disabled]="isHubLogSearchLoading"
                >
                  <mat-icon role="img" aria-label="refresh">refresh</mat-icon>
                  {{ this.translationService.translate('clearSelectionText') }}
                </button>

                <button
                  id="hub-search-button"
                  mat-flat-button
                  color="primary"
                  (click)="submitSearchHub()"
                  [disabled]="isHubLogSearchLoading"
                >
                  @if (isHubLogSearchLoading) {
                  <mat-icon class="loading-icon">autorenew</mat-icon>
                  {{ translationService.translate('loadingText') || 'Loading...' }}
                  } @else {
                  <mat-icon>search</mat-icon>
                  {{ translationService.translate('searchButtonText') }}
                  }
                </button>
              </div>
            </form>

            @if (hubLogTableActive) { @if (isDeleteHubRecordLoading) {
            <div class="delete-loader">
              <mat-icon class="delete-loader-icon">autorenew</mat-icon>
            </div>
            }

            <mic-table #hubLogTable class="table-stripped" id="hub-log-table" [config]="tableConfigHub" [fetcher]="fetcherHub">
              <ng-container *micTableNoData>
                <mic-empty-state icon="layers_clear" title="No Hub Log found"></mic-empty-state>
              </ng-container>

              <ng-container *micCellTemplate="let item; name: 'endStatusCell'">
                @if (!item.endStatus || item.endStatus.toString().trim() === '') {
                <mic-status class="end-status-running">{{ translationService.translate('runningText') || 'Running' }}</mic-status>
                } @else if (item.endStatus.toString().toUpperCase() === 'SUCCESS') {
                <mic-status class="valid">{{ item.endStatus }}</mic-status>
                } @else if (item.endStatus.toString().toUpperCase() === 'FAIL') {
                <mic-status class="end-status-fail">{{ item.endStatus }}</mic-status>
                } @else {
                <span>{{ item.endStatus }}</span>
                }
              </ng-container>

              <ng-container id="table-menu" *micTableRowMenu="let item">
                <button id="view-details" type="button" mat-menu-item (click)="showHubLogDetailsTable(item)">
                  <mat-icon>visibility</mat-icon>
                  {{ translationService.translate('viewDetailsText') }}
                </button>
                <button
                  id="delete-button"
                  type="button"
                  mat-menu-item
                  [disabled]="isDeleteHubRecordLoading"
                  (click)="removeHubRecord(item)"
                >
                  <mat-icon>delete_outline</mat-icon>
                  {{ translationService.translate('deleteMenuText') }}
                </button>
              </ng-container>
            </mic-table>
            }
          </mat-card-content>
        </mat-card>

        @if (showHubLogDetails) {
        <mat-card class="hub-event-card">
          <mat-card-content class="cam-table mt-2 ml-2">
            <div id="process-details-header" class="process-details-header">
              <div>
                <div class="process-details-title">{{ translationService.translate('processDetailsText') }}</div>
                <div class="selected-process-line">
                  {{ translationService.translate('selectedProcessText') }} : {{ selectedHubLogForDetails?.nativeId }}
                </div>
              </div>

              <button type="button" mat-icon-button aria-label="Close details" (click)="closeHubLogDetails()">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <mic-table
              #hubEventLogTable
              class="table-stripped mt-3"
              id="hub-detail-table"
              [config]="tableConfigHubDetail"
              [fetcher]="fetcherHubEvent"
            >
              <ng-container *micTableNoData>
                <mic-empty-state icon="layers_clear" title="No Hub Event Log details found"></mic-empty-state>
              </ng-container>
            </mic-table>
          </mat-card-content>
        </mat-card>
        }
      </div>
    </mat-tab>
    }
  </mat-tab-group>
</div>
